import { AggregationResponseOut } from '../../store/api';
import { FetchAggregationsQuickSearchOptions } from '../listContent/fetchAggregationsQuickSearch';
import { shopPrefix } from '../../config';
import { http } from '../axios';

type Params = FetchAggregationsQuickSearchOptions & {
    ageCategory?: string;
    loanFormat: string;
};

const url = `${shopPrefix}/v1/standard/allproducts/aggregation/quicksearch`;

export function fetchAllProductsAggregationsQuickSearch(params: Params) {
    return http
        .post<AggregationResponseOut>(url, params.filters, {
            params: {
                filterKey: params.filterKey,
                quickSearchQuery: params.quickSearchQuery,
                loanFormat: params.loanFormat,
                ageCategory: params.ageCategory
            }
        })
        .then(response => response.data);
}
